import type { FC } from 'react'
import React from 'react'
import PinLogin from '../pin-login'
import TaskDetailsPageContent from './task-details-page-content'
import type { TaskDetailsPageProps } from './types'

const TaskDetailsPage: FC<TaskDetailsPageProps> = ({ match }) => {
  const {
    params: { taskUuid },
  } = match

  return (
    <PinLogin>
      <TaskDetailsPageContent taskUuid={taskUuid} />
    </PinLogin>
  )
}

export default TaskDetailsPage
